import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IProductoData } from '@core/interfaces/entidades/producto.entidad';
import { IPaginar } from '@core/interfaces/paginacion/paginacion.interface';
import { ICrearProductoReq } from '@core/interfaces/request-response/producto.dto.interface';
import {
  IEditarProductoReq,
  IIngresarProductoInventarioReq,
} from '@core/interfaces/request-response/producto.dto.interface';
import { ETipoProducto } from '@core/enums/tipoProducto.enum';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class ProductoApiService extends BaseHttpService {
  paginar(pagina: number, size: number, categoria_id?: number, tipo_producto?: ETipoProducto) {
    const params = new HttpParams().set('pagina', pagina.toString()).set('size', size.toString());
    return this.withLoader(
      this.httpClient.post<IPaginar<IProductoData>>(
        `${environment.apiUrl}${environment.apiPreFix}/producto/v2/paginar`,
        {
          categoria_id,
          tipo_producto,
        },
        {
          params,
        },
      ),
    );
  }
  buscarProducto(termino: string) {
    const params = new HttpParams().set('termino', termino);
    return this.withLoader(
      this.httpClient.get<IPaginar<IProductoData>>(
        `${environment.apiUrl}${environment.apiPreFix}/producto/v2/buscar`,
        {
          params,
        },
      ),
    );
  }
  /**
   * Búsqueda exacta por código (endpoint opcional). El escáner del POS y el
   * ingreso de inventario usan `buscarProductoSinLoader()` + coincidencia
   * exacta para no depender de que esta ruta esté desplegada.
   */
  buscarPorCodigo(codigo: string) {
    return this.httpClient.get<IProductoData>(
      `${environment.apiUrl}${environment.apiPreFix}/producto/v2/codigo/${encodeURIComponent(codigo)}`,
    );
  }
  /**
   * Búsqueda por término sin el overlay global. Se usa en el ingreso de
   * inventario para escanear varios productos sin parpadeos.
   */
  buscarProductoSinLoader(termino: string) {
    const params = new HttpParams().set('termino', termino);
    return this.httpClient.get<IPaginar<IProductoData>>(
      `${environment.apiUrl}${environment.apiPreFix}/producto/v2/buscar`,
      { params },
    );
  }
  crear(producto: ICrearProductoReq | FormData) {
    return this.withLoader(
      this.httpClient.post<IProductoData>(
        `${environment.apiUrl}${environment.apiPreFix}/producto/v2/crear`,
        producto,
      ),
    );
  }
  guardar(producto_id: number, producto: Partial<IEditarProductoReq> | FormData) {
    return this.withLoader(
      this.httpClient.put<IProductoData>(
        `${environment.apiUrl}${environment.apiPreFix}/producto/v2/guardar/${producto_id}`,
        producto,
      ),
    );
  }
  ingresarInventario(rq: IIngresarProductoInventarioReq[]) {
    return this.withLoader(
      this.httpClient.post<void>(
        `${environment.apiUrl}${environment.apiPreFix}/producto/v2/ingresar-inventario`,
        rq,
      ),
    );
  }
  eliminar(codigo: string) {
    return this.withLoader(
      this.httpClient.delete<{ message: string }>(
        `${environment.apiUrl}${environment.apiPreFix}/producto/v2/eliminar/${codigo}`,
      ),
    );
  }
}
